// Exports
export default {
	"footer": "footer_0JgqH",
	"Link": "Link_FYgZe",
	"buttonSupport": "buttonSupport_xd2OQ",
	"lastRecordButton": "lastRecordButton_45Ytc",
	"buttonInstallApp": "buttonInstallApp_qiRXy",
	"buttonSettings": "buttonSettings_1LTOp",
	"filler": "filler_NjeCY",
	"desktopFooter": "desktopFooter_pfs4L",
	"withText": "withText_-oJt6",
	"buttonsWrapper": "buttonsWrapper_n8QGf",
	"buttonsGroup": "buttonsGroup_ESVJf",
	"disclaimer": "disclaimer_JJn-h",
	"helpWrapper": "helpWrapper_BSCfH",
	"settingsWrapper": "settingsWrapper_WAgGC",
	"installAppButtonTooltip": "installAppButtonTooltip_BmrHX",
	"installAppButtonTooltipClose": "installAppButtonTooltipClose_dztyR",
	"footerWithGlobalBar": "footerWithGlobalBar_4gO6g",
	"footerButton": "footerButton_v2T83",
	"buttonFaq": "buttonFaq_2UGJZ",
	"conferencesHistoryButton": "conferencesHistoryButton_qLIRu"
};
